// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1rqmI","inputWrap":"Table_inputWrap__i6I_n","col":"Table_col__1kBHy","bmiTooltip":"Table_bmiTooltip__28qI_"};